import { render } from "./OutputData.vue?vue&type=template&id=67e3e9c3&scoped=true"
import script from "./OutputData.vue?vue&type=script&lang=js"
export * from "./OutputData.vue?vue&type=script&lang=js"

import "./OutputData.vue?vue&type=style&index=0&id=67e3e9c3&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e3e9c3"]])

export default __exports__